import { AswServiceModel, ReplaceParam } from '@lib/interfaces';
import { AswCommonState, AswContextState } from '@lib/store';
import { UpdateServicesRequestSeats, UpdateServicesRequestServicesInner } from 'src/sdk-servicing';
import { OrderSeatItemSeatSelectionSeatCharacteristicsInner } from 'src/sdk-servicing/model/orderSeatItemSeatSelectionSeatCharacteristicsInner';
import { MFucntionIneligibleReason } from '../master/m_function_ineligble_reason';
import { MNdcOffice } from '../master/m_ndc_office';
import { MOldAndNewErrorMapping } from '../master/m_old_and_new_error_mapping';
import { MPaymentInformation } from '../master/m_payment_information';
import { OfficeByOffceCodeInfo } from '../master/office_by offce_code';
import { ServicingCommonModel } from '../servicing-common';

export interface MyBookingPassengerInfo {
  firstName: string;
  lastName: string;
}

export interface WarningMessageList {
  /** ワーニングメッセージID */
  messageId?: string;
  /** APIエラーコード */
  apiErrorCode?: string;
  /** 埋め込み文字列置換用情報 */
  /**
   * DD sử dụng params
   * source sử dụng interpolateParams
   * params và interpolateParams đồng nghĩa
   * FIXME convert params to interpolateParams
   */
  params?: ReplaceParam[];
}
export interface ErrorMessage {
  // ワーニングメッセージID
  messageId?: string;
  // APIエラーコード
  apiErrorCode?: string;
  // 埋め込み文字列置換用情報
  params?: ReplaceParam[];
}
/** 予約詳細Store */
export interface MyBooking {
  // 1.1.1.	下記にいずれのパラメータは予約詳細storeで保持すること
  /** 国際ASWエラーID */
  aswIntErrorId?: string;
  /** 国際ASW内遷移 */
  aswIntTransition?: boolean;
  /** 予約一覧表示有無 */
  isDisplayReservationList?: boolean;
  /** 旅程ID */
  journeyID?: string;
  /** セグメントIDリスト */
  flightIds?: string[];
  /** 外部サイト区分 */
  externalSiteType?: string;
  /** 次に行うアクション実施済み有無 */
  nextActionImplemented?: boolean;

  /** 請求番号 */
  creditDetailNo?: string;
  /** 出張管理番号 */
  businessTripNo?: string;
  /** 搭乗年月指定 */
  depYearMonth?: string;
  /** 搭乗開始日 */
  depTermStartDate?: string;
  /** 搭乗終了日 */
  depTermEndDate?: string;
  /** 購入/払戻年月指定 */
  payYearMonth?: string;
  /** 購入/払戻開始日 */
  payTermStartDate?: string;
  /** 購入/払戻終了日 */
  payTermEndDate?: string;
  /** 検索時企業精算CD */
  searchedCompanyAccountCd?: string;
  /** 発着空港from */
  airportFrom?: string;
  /** 発着空港to */
  airportTo?: string;
  /** 便名 */
  flightInfo?: string;
  /** 搭乗者姓(出張旅程一覧の検索用) */
  passengerNmLast?: string;
  /** 搭乗者名(出張旅程一覧の検索用) */
  passengerNmFirst?: string;
  /** ページ番号(出張旅程一覧のページ復帰用) */
  pagingNo?: string;
  /** 提携: 言語 */
  lang?: string;
  // 1.1.2.	下記にいずれのパラメータはサービシング共通storeで保持すること

  // others
  /** 第3言語コード */
  lang3rd?: string;
  /** 規約からの再表示であるか */
  isReload?: boolean;
  /** APF説明表示要否 */
  explainAPF?: boolean;
  /** ANABiz説明表示要否 */
  explainANABiz?: boolean;
  /** PNR説明表示要否 */
  explainPNR?: boolean;
  /** 規約表示要否 */
  displayTermAndCondition?: boolean;
  /** 未入会搭乗者 */
  unEnrolledPassengers?: UnEnrolledPassenger[];

  officeInfoAfterRedirectCode?: string;
  /** 遷移元でマスキングなしのPNR */
  isNoMaskingPNRTransition?: boolean;

  hasUnEnrolledPassengers?: boolean;

  /** チェックインサービス申込に */
  checkInServiceApplication?: boolean;

  /** 予約1件フラグ */
  is1ReservationFlg?: boolean;

  /** トランジット情報 */
  transitInfo?: TransitInfoPassenger;

  /** 搭乗者情報系サポート */
  travelerSupports?: object;

  /**
   * 登録済み
   * true:登録済みの旨
   * false:未登録の旨
   */
  favoriteBtnIsRegistered?: boolean;

  /** 予約情報を表示するフラグ */
  isDisplayReservation?: boolean;

  /** 予約番号 */
  orderId?: string;

  /** 航空券番号 */
  travelDocumentId?: string;

  /** 名 */
  firstName?: string;

  /** 姓 */
  lastName?: string;

  /*** 遷移元画面識別子リスト */
  sourceScreenIdentifierList?: string[];
}

export interface TransitInfoPassenger {
  [key: string]: { isTransit?: boolean };
}

export interface UnEnrolledPassenger {
  /**
   * 搭乗者ID
   */
  id?: string;
  /**
   * 名前情報
   */
  title?: string;
  firstName?: string;
  lastName?: string;
  gender?: string;
  dateOfBirth?: string;
  mail?: string;
  country?: string;
}
export interface MasterDataS01P030 {
  mNdcOffice?: Array<MNdcOffice>;
  officeByOffceCode?: Array<OfficeByOffceCodeInfo>;
  mFucntionIneligibleReason?: MFucntionIneligibleReason;
  mPaymentInformation?: Array<MPaymentInformation>;
  mOldAndNewErrorMapping?: MOldAndNewErrorMapping;
}

export const INITIAL_MYBOOKING_MASTER_DATA: MasterDataS01P030 = {
  mNdcOffice: [],
  officeByOffceCode: [],
  mFucntionIneligibleReason: undefined,
  mPaymentInformation: [],
  mOldAndNewErrorMapping: undefined,
};

export const INITIAL_MYBOOKING_STATE: MyBooking = {
  aswIntErrorId: '',
  aswIntTransition: false,
  isDisplayReservationList: false,
  isReload: false,
  hasUnEnrolledPassengers: false,
  unEnrolledPassengers: [],
  isNoMaskingPNRTransition: false,
  lang3rd: '',
  displayTermAndCondition: false,
  journeyID: '',
  flightIds: [],
  externalSiteType: '',
  nextActionImplemented: false,
  officeInfoAfterRedirectCode: '',
  explainAPF: false,
  explainANABiz: false,
  explainPNR: false,
  checkInServiceApplication: false,

  creditDetailNo: '',
  businessTripNo: '',
  depYearMonth: '',
  depTermStartDate: '',
  depTermEndDate: '',
  payYearMonth: '',
  payTermStartDate: '',
  payTermEndDate: '',
  searchedCompanyAccountCd: '',
  airportFrom: '',
  airportTo: '',
  flightInfo: '',
  passengerNmLast: '',
  passengerNmFirst: '',
  pagingNo: '',
};

/**
 * S01-P030: Initialize State
 */
export interface MyBookingInitializeParams {
  aswCommon: AswCommonState;
  aswContext: AswContextState;
  myBookingState: MyBooking;
  servicingCommonModel: ServicingCommonModel;
}

export interface ChargeableLoungePassengerApplyInfo {
  // SSRコード
  ssrCode?: string;
  // 有料サービス金額
  paidServiceAmount?: number;
  // 更新区分
  updateCategory?: string;
}

export interface ChargeableLoungePassengerApplyStatusMap {
  // 搭乗者別申込状況マップ
  [travelerId: string]: ChargeableLoungePassengerApplyInfo | undefined;
}

export interface ChargeableLounge {
  // 申込操作中フラグ
  isApplicationProcessed?: boolean;
  // バウンドID
  airBoundId?: string;
  // 合計金額
  totalAmount?: number;
  // 搭乗者別申込状況マップ
  [flightId: string]: ChargeableLoungePassengerApplyStatusMap | boolean | number | string | undefined;
}

export interface FirstBaggageBoundMap {
  // セグメントID
  segmentId?: string;
  // 搭乗者別申込状況マップ
  [travelerId: string]: FirstBaggagePassengerApplyInfo | string | undefined;
}

export interface FirstBaggagePassengerApplyInfo {
  // 有料サービス金額
  paidServiceAmount?: number;
  // 更新区分
  updateCategory?: string;
}

export interface FirstBaggage {
  // 申込操作中フラグ
  isApplicationProcessed?: boolean;
  // バウンドマップ
  [boundId: string]: FirstBaggageBoundMap | boolean | number | undefined;
  // 合計金額
  totalAmount?: number;
}

export interface MealPassengerApplyInfo {
  /** 機内食種別 */
  mealType?: string;
  /** SSRコード */
  ssrCode?: string;
  /** 事前ミールメッセージID */
  mealMessageId?: string;
  /** 有料サービス金額 */
  paidServiceAmount?: number;
  /** 更新区分 */
  updateCategory?: string;
}

export interface MealCatalogItem {
  // SSRコード
  ssrCode?: string;
  // 在庫数
  quota?: number;
}

export interface MealPassengerApplyStatusMap {
  // 搭乗者別申込状況マップ
  [travelerId: string]: MealPassengerApplyInfo | Object | undefined;
  // 有料機内食カタログ情報
  mealCatalog?: MealCatalogItem[];
}

export interface MealInformation {
  // 申込操作中フラグ
  isApplicationProcessed?: boolean;
  // バウンドID
  airBoundId?: string;
  // セグメントマップ: [flightId: string]
  [flightId: string]: MealPassengerApplyStatusMap | string | boolean | number | undefined;
  // 有料機内食申込有無
  mealInsertFlg?: boolean;
  // 有料機内食削除有無
  mealDeleteFlg?: boolean;
  // 合計金額
  totalAmount?: number;
}

export interface SeatPassengerApplyInfo {
  /** 座席番号 */
  seatNumber?: Array<string>;

  /** カウチ席番号 */
  couchSeatNumber?: string;

  /** 座席属性 */
  seatAttribute?: string;

  /** 座席ステータス */
  seatStatus?: string;

  /** カウチ席かどうか */
  isCouchSeat?: boolean;

  /** 有料ASR席フラグ */
  isPaidASRSeat?: boolean;

  /** 有料サービス金額 */
  paidServiceAmount?: string;

  /** 更新区分 */
  updateCategory?: string;

  /** SSRコード */
  ssrCode?: string;

  /** 座席特定 */
  seatCharacteristics?: OrderSeatItemSeatSelectionSeatCharacteristicsInner[];

  /** チャイルドシート */
  childSeat?: string;

  // バシネット
  bassinet?: boolean;

  /** チャイルドシート更新区分 */
  childSeatUpdateCategory?: string;
}

export interface SeatPassengerApplyStatusMap {
  // 搭乗者別申し込み状況マップ
  [travelerId: string]: SeatPassengerApplyInfo | undefined;
}

export interface SeatReservation {
  // 申込操作中かどうか
  isApplicationProcessed?: boolean;
  // セグメントマップ: [flightId: string]
  [flightId: string]: SeatPassengerApplyStatusMap | string | boolean | number | undefined;
  // 合計金額
  totalAmount?: number;
  // 有料ASR席またはカウチ席削除フラグ
  paidAsrCouchSeatDeletionFlag?: boolean;
}
export interface ServiceInfoData {
  /** サービス申込情報リスト */
  services?: Array<UpdateServicesRequestServicesInner>;
  /** 座席指定セグメントリスト */
  seatReservationList?: Array<string>;
  /** 座席指定情報 */
  seats?: UpdateServicesRequestSeats;
}
export interface ChargeableLoungeEmds {
  hasEmd?: boolean;
  hasSegmentAssociatedEmd?: boolean;
}
export interface FirstBaggageEmds {
  hasEmd?: boolean;
  hasSegmentAssociatedEmd?: boolean;
}
export interface MealEmds {
  hasEmd?: boolean;
  hasSegmentAssociatedEmd?: boolean;
}
export interface PassengerEmds {
  chargeableLounge: ChargeableLoungeEmds;
  firstBaggage: FirstBaggageEmds;
  meal: MealEmds;
}
export interface Emds {
  [travelerId: string]: PassengerEmds;
}

export interface IOfflineOfficeCityCode {
  city_code: string;
  pos_country_code: string;
  last_modification_date_time: string;
}

export namespace PaidDivisionStatus {
  export type PaidDivisionEnum = '' | '0' | '1';
  export const PaidDivisionEnum = {
    Empty: '' as PaidDivisionEnum,
    Domestic: '0' as PaidDivisionEnum,
    International: '1' as PaidDivisionEnum,
  };
}
